import {
    showConfirmationDialog,
    showErrorToast
} from '@/helpers/alert';
import { useAuthStore } from '@/state/pinia';
import axios from 'axios';

// Pastikan window.__APP__ dan $pinia ada
// const app = window.__APP__;

export function axiosInterceptors() {
    const auth = useAuthStore();
    axios.interceptors.request.use(config => {
        const token = auth.getToken(); // Mengakses Pinia store dari globalProperties
        const source = axios.CancelToken.source();
        config.cancelToken = source.token;

        const timer = setTimeout(() => {
            source.cancel('Request canceled by timeout');
        }, 60000);
        config.timeout = timer;

        // if (['GET', 'PUT', 'POST', 'DELETE'].includes(config.method.toUpperCase())) {
        // }

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            // Menambahkan token ke header
        }

        if (!config.headers['Content-Type']) {
            config.headers['Content-Type'] = 'application/json'; // Menetapkan Content-Type jika tidak ada
        }

        config.headers['Accept'] = 'application/json'; // Menetapkan Accept header

        return config;
    }, error => {
        showErrorToast('Request Error', 'Terjadi kesalahan pada request'); // Menampilkan toast error
        return Promise.reject(error);
    });

    axios.interceptors.response.use(response => {
        clearTimeout(response.config.timeout);

        return response;
    }, async error => {
        if(error.response && error.response.status === 403 && error.response.data.errors[0].includes("kadaluarsa")){
            await auth.refresh();
            window.location.reload();
        } else if (error.response && [403, 401].includes(error.response.status)) {
            // Menampilkan konfirmasi sebelum melakukan logout jika error 403 atau 401
            const confirmed = await showConfirmationDialog(
                'Ooops',
                error.response.data.errors[0] || 'Terjadi kesalahan pada response'
            );
            if (confirmed) {
                await auth.logout(); // Menghapus token dari Pinia store dan localStorage
                window.location.href = '/login'; // Memuat ulang halaman
            }
        } else if (error.response && error.response.status === 408) {
            showErrorToast('Request Timeout', 'Terjadi kesalahan pada request');
        }
        else {
            showErrorToast('Error', 'Terjadi kesalahan pada response'); // Menampilkan toast error untuk kesalahan lainnya
        }

        if (error.message === 'Request Timeout') {
            showErrorToast('Request Timeout', 'Terjadi kesalahan pada request');
        }

        return Promise.reject(error);
    });
}
